<div class="navbar">
    <div class="mobile-version__drawer-container">
      <button mat-button class="menu-button" (click)="sidenav.toggle()">
        <mat-icon>{{ isMenuOpen ? "menu_open" : "menu" }}</mat-icon>
      </button>
      <mat-sidenav-container class="sidenav-container">
        <mat-sidenav
          #sidenav
          autoFocus="false"
          mode="over"
          [(opened)]="isMenuOpen"
          class="sidenav"
          (click)="onSidenavClick()"
        >
          <div class="drawer__buttons">
            <mat-accordion>
              <p *ngIf="permissionsService.hasPermission('payments-module.plati-online.list')"
                class="menu-link" routerLink="/plati-online" [class.menu-active]="'/plati-online' === activeRoute" (click)="setActiveRoute('/plati-online')">
                <img src="/assets/icons/plati-online.svg" alt="Plăți Online" />
                <span>Plăți online</span>
              </p>
              <p *ngIf="permissionsService.hasPermission('payments-module.interogari-plati.list')"
                class="menu-link" routerLink="/interogari-plati" [class.menu-active]="'/interogari-plati' === activeRoute" (click)="setActiveRoute('/interogari-plati')">
                <img src="/assets/icons/interogari-plati.svg" alt="Amenzi Achitate" />
                <span>Interogari și plăți</span>
              </p>
              <p *ngIf="permissionsService.hasPermission('payments-module.amenzi-achitate.list')" 
                class="menu-link" routerLink="/amenzi-achitate" [class.menu-active]="'/amenzi-achitate' === activeRoute" (click)="setActiveRoute('/amenzi-achitate')">
                <img src="/assets/icons/amenzi-achitate.svg" alt="Amenzi Achitate" />
                <span>Amenzi achitate</span>
              </p>
              <p *ngIf="permissionsService.hasPermission('payments-module.taxe-nedebitate-achitate.list')" 
              class="menu-link" routerLink="/taxe-nedebitate-achitate" [class.menu-active]="'/taxe-nedebitate-achitate' === activeRoute" (click)="setActiveRoute('/taxe-nedebitate-achitate')">
              <img src="/assets/icons/taxe-nedebitate-achitate.svg" alt="Taxe Nedebitate Achitate" />  
              <span>Taxe nedebitate achitate</span>
              </p>
              <p *ngIf="permissionsService.hasPermission('payments-module.settings.tipuri-amenzi.list') || 
                permissionsService.hasPermission('payments-module.settings.tipuri-taxe-nedebitate.list')" 
                class="menu-link" routerLink="/settings" [class.menu-active]="'/settings' === activeRoute" (click)="setActiveRoute('/settings')">
                <img src="/assets/icons/settings.svg" alt="Setări" />
                <span>Setări</span>
              </p>

              <!-- </mat-expansion-panel> -->

                <mat-expansion-panel *ngIf="permissionsService.hasPermission('payments-module.administrative')"
                    class="sidenav-accordion" (opened)="panelOpenState2 = true" (closed)="panelOpenState2 = false">
                    <mat-expansion-panel-header class="sidenav-accordion">
                        <mat-panel-title class="sidenav-accordion" [class.hide-line]="panelOpenState2">
                            <div class="panel-title">
                                <img src="/assets/icons/administrative.svg" alt="Setări" />
                                <span>Administrativ</span>
                            </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <p routerLink="/admin-settings" class="settings-option-menu" [class.menu-active]="'/admin-settings' === activeRoute" (click)="setActiveRoute('/admin-settings')">
                        <img src="/assets/icons/settings.svg" alt="Setări" />
                        <span>Setări</span>
                    </p>
                </mat-expansion-panel>
            </mat-accordion>
  
            <div class="footer">
              <div class="logout-button" (click)="logout()">
                <img src="assets/icons/logout.svg" alt="Deconectare" />
                <div class="logout-button--text">Deconectare</div>
              </div>
            </div>
          </div>
        </mat-sidenav>
        <mat-sidenav-content>
          <main>
            <!-- <router-outlet></router-outlet> -->
          </main>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </div>
    <div class="username">{{ username }}</div>
    <div class="username__icon">
      <div class="username__icon--letters">{{ usernameLetters }}</div>
    </div>
  </div>
  